const base = APPLICATION_ENV.SEARCH_API;
const searchApis = {
  search: {
    searchGoodsByKey: `${base}goods/backplat/searchGoodsByKey`, // 商品运营端搜索:查询商品信息
  },
};

export default searchApis;
